// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetAppSystemWebApiByIdRequestModel from '../../model/get-app-system-web-api-by-id-request-model';
import GetAppSystemWebApiByIdRequestDTO from '../dto/get-app-system-web-api-by-id-request-dto';
import dtoSchema from '../schemas/get-app-system-web-api-by-id-request-schema';

export default abstract class GetAppSystemWebApiByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetAppSystemWebApiByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetAppSystemWebApiByIdRequestDTO>): GetAppSystemWebApiByIdRequestModel;
  static toModel(dto: DeepPartial<GetAppSystemWebApiByIdRequestDTO> | undefined | null): GetAppSystemWebApiByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetAppSystemWebApiByIdRequestDTO> | undefined | null): GetAppSystemWebApiByIdRequestModel | undefined {
    return dto ? new GetAppSystemWebApiByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetAppSystemWebApiByIdRequestModel> | GetAppSystemWebApiByIdRequestModel): GetAppSystemWebApiByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetAppSystemWebApiByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetAppSystemWebApiByIdRequestModel, can not map to GetAppSystemWebApiByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
